export const classNames = (
  ...args: Array<string | boolean | undefined>
): string => {
  return args.filter((a) => typeof a === "string").join(" ");
};
